var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row pb-3", attrs: { id: "faq" } }, [
    _c("div", { staticClass: "col-12" }, [
      _c("h2", {
        staticClass: "mb-1",
        domProps: { innerHTML: _vm._s(_vm.faqTitle) },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "accordion",
          attrs: { itemscope: "", itemtype: "https://schema.org/FAQPage" },
        },
        _vm._l(_vm.faqListOfAttributes, function (attribute, attributeIndex) {
          return _c(
            "div",
            {
              key:
                "faqAttribute_" +
                (attribute.faqTmsDTO && attribute.faqTmsDTO.action
                  ? attribute.faqTmsDTO.action
                  : "") +
                "_" +
                attributeIndex,
            },
            [
              _c(
                "div",
                {
                  staticClass: "card multi",
                  attrs: {
                    itemscope: "",
                    itemprop: "mainEntity",
                    itemtype: "https://schema.org/Question",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { id: "heading-" + attributeIndex },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "collapsed",
                          attrs: {
                            id: "heading-button-" + attributeIndex,
                            "data-bs-toggle": "collapse",
                            "data-bs-target": "#collapse-" + attributeIndex,
                            "aria-controls": "#collapse-" + attributeIndex,
                            "aria-expanded": "false",
                            "data-oevent-category":
                              attribute.faqTmsDTO.category,
                            "data-oevent-action": attribute.faqTmsDTO.action,
                            "data-oevent-label": attribute.faqTmsDTO.label,
                          },
                        },
                        [
                          _c("span", { staticClass: "accordion-card-title" }, [
                            _c("span", {
                              staticClass: "h3 accordion-title mb-0",
                              attrs: { itemprop: "name" },
                              domProps: { innerHTML: _vm._s(attribute.title) },
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "accordion-icon",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse-" + attributeIndex,
                        "aria-labelledby": "heading-button-" + attributeIndex,
                        role: "region",
                        itemscope: "",
                        itemprop: "acceptedAnswer",
                        itemtype: "https://schema.org/Answer",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "accordion-card-body standard",
                          attrs: { itemprop: "text" },
                        },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(attribute.text) },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }